import { Link, useLocation } from "react-router-dom";
import useSEO from "@/hooks/useSEO";

export default function NotFound() {
  const location = useLocation();

  useSEO({
    title: "页面不存在 | 爆料专区",
    description:
      "你访问的页面不存在或已调整地址。可以返回爆料专区首页，或前往年度盘点档案库继续浏览历史热点与旧瓜复盘内容。",
    keywords: "爆料专区,页面不存在,年度盘点,档案库",
    canonical: location.pathname,
    ogType: "website",
  });

  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto flex w-full max-w-[1400px] flex-col items-start px-4 py-20 md:px-6 md:py-28">
        <p className="font-heading text-6xl font-black text-primary-500 md:text-8xl">404</p>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          这份档案暂时不存在
        </h1>
        <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
          你访问的地址可能已经调整，或者对应的档案尚未整理完成。可以回到首页，或者直接去档案库按主题和年份翻找。
        </p>
        <p className="mt-4 inline-flex items-center gap-2 rounded-md bg-background-100 px-3 py-1.5 font-mono text-xs text-foreground-500">
          <i className="ri-link" />
          {location.pathname}
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line" />
            返回首页
          </Link>
          <Link
            to="/archive"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            <i className="ri-archive-2-line" />
            进入档案库
          </Link>
        </div>
      </div>
    </section>
  );
}